import React, { useEffect, useState } from "react";
import {
    Box, Typography, Select, MenuItem, InputLabel, Button,
    Table, TableHead, TableBody, TableCell, TableRow, TableContainer,
    Paper, CircularProgress, Alert, Snackbar
} from "@mui/material";
import { getFirestore, collection, getDocs, query, where } from "firebase/firestore";
import Payroleheader from "./Payroleheader";

const db = getFirestore();

function Staffpayreport() {
    const [staffList, setStaffList] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState("");
    const [report, setReport] = useState([]);
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });

    // fetch staff list on component mount
    useEffect(() => {
        const fetchStaff = async () => {
            try {
                const snap = await getDocs(collection(db, "staffdetails"));
                setStaffList(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
            } catch (error) {
                console.error("Error fetching staff list:", error);
                setAlert({ open: true, message: "Failed to fetch staff list.", severity: "error" });
            }
        };
        fetchStaff();
    }, []);

    // fetch report
    const getReport = async () => {
        if (!selectedStaff) {
            setAlert({ open: true, message: "Please select a staff member.", severity: "warning" });
            return;
        }

        setLoading(true);
        setReport([]);

        try {
            // fetch payments
            const paymentSnap = await getDocs(
                query(collection(db, "staffpayments"), where("staffid", "==", selectedStaff))
            );
            const payments = paymentSnap.docs.map((d) => ({
                id: d.id,
                ...d.data(),
                type: "Payment",
                displayDate: d.data().paydate,
            }));

            // fetch advances
            const advanceSnap = await getDocs(
                query(collection(db, "staffadvance"), where("staffid", "==", selectedStaff))
            );
            const advances = advanceSnap.docs.map((d) => ({
                id: d.id,
                ...d.data(),
                type: "Advance",
                displayDate: d.data().date,
            }));

            // merge and sort all transactions
            const combinedReport = [...payments, ...advances];
            combinedReport.sort((a, b) => new Date(b.displayDate) - new Date(a.displayDate));

            setReport(combinedReport);
        } catch (error) {
            console.error("Error fetching report:", error);
            setAlert({ open: true, message: "Failed to generate report.", severity: "error" });
        } finally {
            setLoading(false);
        }
    };

    // print report
    const handlePrint = () => {
        if (report.length === 0) {
            setAlert({ open: true, message: "No report to print. Please generate a report first.", severity: "warning" });
            return;
        }

        const printContent = document.getElementById("report-table").outerHTML;
        const newWindow = window.open("", "", "width=800,height=600");
        newWindow.document.write("<html><head><title>Staff Salary Report</title></head><body>");
        newWindow.document.write(printContent);
        newWindow.document.write("</body></html>");
        newWindow.document.close();
        newWindow.print();
    };

    return (
        <Box p={3}>
            <Payroleheader />
            <Typography variant="h5" fontWeight="bold" gutterBottom>
                स्टाफ पगार अहवाल
            </Typography>

            <InputLabel id="staff-select-label">स्टाफ निवडा</InputLabel>
            <Select
                labelId="staff-select-label"
                fullWidth
                size="small"
                value={selectedStaff}
                onChange={(e) => setSelectedStaff(e.target.value)}
                sx={{ mb: 2 }}
            >
                {staffList.map((s) => (
                    <MenuItem key={s.id} value={s.id}>
                        {s.staffname}
                    </MenuItem>
                ))}
            </Select>

            <Button variant="contained" onClick={getReport} sx={{ mb: 2 }}>
                अहवाल मिळवा
            </Button>
            <Button variant="outlined" onClick={handlePrint} sx={{ mb: 2, ml: 2 }}>
                अहवाल छापा
            </Button>

            {loading && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <CircularProgress />
                </Box>
            )}

            {report.length > 0 && (
                <TableContainer
                    component={Paper}
                    id="report-table"
                    sx={{ mt: 2, boxShadow: 6, borderRadius: 2, overflow: 'hidden' }}
                >
                    <Table>
                        <TableHead sx={{ backgroundColor: 'primary.main' }}>
                            <TableRow>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>तारीख</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>प्रकार</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>रक्कम</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>नोंद</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {report.map((item) => (
                                <TableRow key={item.id} sx={{ '&:nth-of-type(odd)': { backgroundColor: '#f9f9f9' } }}>
                                    <TableCell>{new Date(item.displayDate).toLocaleDateString()}</TableCell>
                                    <TableCell>{item.type === "Payment" ? "पगार" : "उचल"}</TableCell>
                                    <TableCell>
                                        {item.type === "Payment" ? item.paidSalary : item.advanceamount}
                                    </TableCell>
                                    <TableCell>
                                        {item.type === "Payment"
                                            ? `पगार - ${new Date(item.paydate).toLocaleString('default', { month: 'long' })}`
                                            : `उचल - ${item.reason}`}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            <Snackbar open={alert.open} autoHideDuration={6000} onClose={() => setAlert({ ...alert, open: false })}>
                <Alert onClose={() => setAlert({ ...alert, open: false })} severity={alert.severity} sx={{ width: '100%' }}>
                    {alert.message}
                </Alert>
            </Snackbar>
        </Box>

    );
}

export default Staffpayreport;